import { render, staticRenderFns } from "./testExamine.vue?vue&type=template&id=0d7d80db&scoped=true&"
import script from "./testExamine.vue?vue&type=script&lang=js&"
export * from "./testExamine.vue?vue&type=script&lang=js&"
import style0 from "./testExamine.vue?vue&type=style&index=0&id=0d7d80db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d80db",
  null
  
)

export default component.exports